// extracted by mini-css-extract-plugin
export var completionBody = "_h2-2";
export var completionCard = "_h2-0";
export var completionFooter = "_h2-3";
export var completionTitle = "_h2-1";